(function () {
  'use strict';

  angular
    .module('myMemberships.import')
    .config(config);

  function config($stateProvider, configOptions) {
    $stateProvider
      .state('myMemberships.import', angular.extend({}, configOptions.defaultStateParams, {
        url: '/import',
        templateUrl: 'my-memberships/my-memberships.tpl.html',
        controller: 'MyMembershipsCtrl',
        controllerAs: 'myMemberships',
        params: {
          leadToOpen: null
        },
        onEnter: ['RouterHelper', function (RouterHelper) {
          RouterHelper.activateTab('myMemberships', 'import');
        }]
      }));
  }
}());
